// extracted by mini-css-extract-plugin
export default {"containerSearch":"SearchBar_containerSearch__IJpKh"};